export const cookiePolicyLinks = {
  googlePolicy: 'https://policies.google.com/privacy',
  facebookPolicy: 'https://www.facebook.com/privacy/explanation',
  hotjarPolicy: 'https://www.hotjar.com/legal/policies/privacy',
  synerisePolicy: 'https://www.synerise.com/legal/privacy-policy',
};
